<app-table [data]="tickets"
           [config]="tableConfig"
           [isLoading]="isLoading"
           [rowExpand]="false"
           [isMaterial]="false"
           [hasTitle]="hasTitle"
           [headerBackgroundColor]="headerBackgroundColor"
           title="{{'admin.tickets.table.title' | translate}}"
           (sortChange)="onSortChange($event)"
           (filterChange)="onFilterChange($event)"
           (pageChange)="onPageChange($event)"
           (rowClick)="onRowClick($event)">
    <app-table-column header="{{'admin.tickets.table.columns.id' | translate}}"
                      filterPlaceholder="{{'admin.tickets.table.filter.placeholder.id' | translate}}"
                      sortable="true"
                      field="id">
        <ng-template #filter let-column="column" let-table="table">
            <app-input type="number"
                       mask="0*"
                       [placeholder]="'admin.tickets.table.filter.placeholder.id' | translate"
                       [(ngModel)]="column.filterValue"
                       (ngModelChange)="table.onFilterChange(column)">
            </app-input>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.tickets.table.columns.status' | translate}}"
                      sortable="true"
                      field="status">
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-dropdown [(ngModel)]="column.filterValue"
                          [items]="filterStatusList"
                          valueField="value"
                          displayField="name"
                          [emptyText]="'admin.tickets.table.filter.placeholder.status' | translate"
                          (selectItem)="onStatusFilterChange(column, table)"></app-dropdown>
        </ng-template>
        <ng-template #body
                     let-tool="rowData">
            <span>{{ tool.status | translate }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.tickets.table.columns.createdBy' | translate}}"
                      filterPlaceholder="{{'admin.tickets.table.filter.placeholder.createdBy' | translate}}"
                      filter="true"
                      sortable="true"
                      field="createdBy">
        <ng-template #body
                     let-ticket="rowData">
            <span translate>{{ ticket.createdByName }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.tickets.table.columns.createdDate' | translate}}"
                      sortable="true"
                      field="createdDate">
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-input-datepicker [(ngModel)]="column.filterValue"
                                  [appendTo]="'body'"
                                  [placeholder]="'admin.tickets.table.filter.placeholder.createdDate' | translate"
                                  (dateChange)="table.onFilterChange(column)">
            </app-input-datepicker>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.tickets.table.columns.startDate' | translate}}"
                      sortable="true"
                      field="startDate">
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-input-datepicker [(ngModel)]="column.filterValue"
                                  [appendTo]="'body'"
                                  [placeholder]="'admin.tickets.table.filter.placeholder.startDate' | translate"
                                  (dateChange)="table.onFilterChange(column)">
            </app-input-datepicker>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.tickets.table.columns.endDate' | translate}}"
                      sortable="true"
                      field="endDate">
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-input-datepicker [(ngModel)]="column.filterValue"
                                  [appendTo]="'body'"
                                  [placeholder]="'admin.tickets.table.filter.placeholder.endDate' | translate"
                                  (dateChange)="table.onFilterChange(column)">
            </app-input-datepicker>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.tickets.table.columns.isAutomatic' | translate}}"
                      sortable="true"
                      field="isAutomatic">
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-dropdown [(ngModel)]="column.filterValue"
                          [items]="filterAutomaticList"
                          valueField="value"
                          displayField="name"
                          emptyText="{{'admin.tickets.table.filter.placeholder.isAutomatic' | translate}}"
                          (selectItem)="table.onFilterChange(column)"></app-dropdown>
        </ng-template>
        <ng-template #body
                     let-ticket="rowData">
            <span
                translate>{{ ticket.isAutomatic ? 'admin.tickets.table.isAutomatic.true' : 'admin.tickets.table.isAutomatic.false' }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column sortable="true"
                      field="hasPriority">
        <ng-template #body
                     let-ticket="rowData">
            <app-tooltip *ngIf="ticket.hasPriority" type="info" class="priority-tooltip"
                         record="{{'admin.tickets.table.ticketPriority' | translate}}">
            </app-tooltip>
        </ng-template>
    </app-table-column>
</app-table>
